import MurphyLogo from "@/components/shared/MurphyLogo";
import { useAuth } from "@/lib/AuthContext";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-ink px-4" data-testid="pending-approval-page">
      <div className="max-w-md w-full bg-white rounded-3xl p-10 text-center shadow-2xl">
        <div className="flex justify-center mb-8">
          <MurphyLogo size="lg" />
        </div>
        <div className="w-16 h-16 rounded-2xl bg-brand-limeSoft text-brand-limeDark flex items-center justify-center mx-auto mb-5">
          <Clock className="w-8 h-8" />
        </div>
        <h1 className="text-2xl font-extrabold text-brand-ink tracking-tight">Venter på godkjenning</h1>
        <p className="text-slate-500 mt-3 leading-relaxed">
          Kontoen din{user?.email ? <> (<span className="font-medium text-brand-ink">{user.email}</span>)</> : null} er registrert
          og venter på at en administrator godkjenner tilgangen. Du får tilgang så snart kontoen er godkjent.
        </p>
        <Button onClick={logout} variant="outline" className="mt-8 w-full" data-testid="pending-logout-btn">
          <LogOut className="w-4 h-4 mr-2" /> Logg ut
        </Button>
      </div>
    </div>
  );
}
